/* Glossary tooltip injector – v2 */
document.addEventListener('DOMContentLoaded', initGlossary);
document.addEventListener('shopify:section:load',   initGlossary);

function initGlossary() {
  if (!window.GLOSSARY || !Object.keys(window.GLOSSARY).length) return;

  // build your regex of glossary terms
  const terms   = Object.keys(window.GLOSSARY);
  const pattern = terms.map(t => t.replace(/-/g,'[-\\s]')).join('|');
  const regex   = new RegExp(`\\b(${pattern})\\b`, 'gi');

  // these are the only ULs we *would* walk—but we’ll skip any inside #CollectionSidebar
  const selector = [
    '[id^="deets-track"] ul',
    '.collapsible-content ul'
  ].join(',');

  document.querySelectorAll(selector).forEach(ul => {
    // SKIP the filter rail
    if (ul.closest('#CollectionSidebar')) return;

    const walker = document.createTreeWalker(ul, NodeFilter.SHOW_TEXT);
    const textNodes = [];
    while (walker.nextNode()) textNodes.push(walker.currentNode);

    textNodes.forEach(node => {
      if (!regex.test(node.textContent)) return;

      const span = document.createElement('span');
      span.innerHTML = node.textContent.replace(regex, match => {
        const key = match.trim().toLowerCase().replace(/\s+/g,'-');
        return `<span class="bf-term" data-term="${key}">${match}</span>`;
      });
      node.parentNode.replaceChild(span, node);
    });
  });

  /* Build the pop-ups */
  if (typeof tippy !== 'function') return;

  // Grab all bf-term elements and drop any inside #CollectionSidebar
  const termsToTip = Array.from(document.querySelectorAll('.bf-term'))
                          .filter(el => !el.closest('#CollectionSidebar'));

  tippy(termsToTip, {
    allowHTML:     true,
    interactive:   true,
    animation:     'shift-away',
    theme:         'light-border',
    appendTo:      () => document.body,
    content(ref) {
      const d = window.GLOSSARY[ref.dataset.term] || {};
      const purpose = Array.isArray(d.purpose) ? d.purpose.join(' • ') : d.purpose || '';
      const perks   = Array.isArray(d.perks)   ? d.perks.join(' • ')   : d.perks   || '';
      const aroma   = d.aroma || '';
      const chipHTML = d.chip 
        ? `<span class="bf-chip" style="background:${d.chip};"></span>` 
        : '';

      return `
        <div class="bf-tip">
          <img src="${d.img}" alt="${d.title}" class="bf-tip-thumb">
          <h6 class="bf-tip-title">${d.title}</h6>
          ${d.latin ? `<p class="bf-tip-latin"><em>${d.latin}</em></p>` : ''}
          <p class="bf-tip-desc">${d.desc}</p>
          <hr />
          ${aroma   ? `<p class="bf-tip-extra"><span class="label">Aroma:</span><span>${aroma}${chipHTML}</span></p>` : ''}
          ${perks   ? `<p class="bf-tip-extra"><span class="label">On Skin:</span><span>${perks}</span></p>` : ''}
          ${purpose ? `<p class="bf-tip-extra"><span class="label">Purpose:</span><span>${purpose}</span></p>` : ''}
          ${d.url    ? `<a href="${d.url}" target="_blank" rel="noopener" class="bf-tip-link">🔗 More Info</a>` : ''}
        </div>`;
    }
  });
}
